import { Box, Button } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  ErrorServer,
  FoodItemOrder,
  FooterSticky,
  HeaderFoodOrder,
  HeaderTable,
  Loading,
  OrderEmpty,
  SummaryPayment,
} from '~/components'
import { loadingStates, paymentTypes } from '~/config/constant'
import { errorMessage, heightFooterSticky, keywordScreen, marginX, STATUS_CODE } from '~/constants'
import { path, route } from '~/routes/path'
import { variantStyles } from '~/theme/constants'
import { ThemeContext } from '~/theme/ThemeProvider'

import { getInfoRestaurant, isInValidArray } from '~/utils'
import ExcludesVAT from '../Menu/components/ExcludesVAT'
import PopupPayment from './components/PopupPayment'

import {
  fetchInfoPayment,
  infoPaymentSelector,
  requestPayment,
  resetStatePayment,
} from './slices/paymentSlice'
import { getTotalPriceIncludeTopping } from '~/utils/order'

const Payment = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isOpenPopup, setIsOpenPopup] = useState(false)
  const { data, loading, error, request } = useSelector(infoPaymentSelector)
  console.log({ error })

  const { currentThemeObject } = useContext(ThemeContext)
  const {
    restaurant,
    table,
    servingRequests,
    subTotal,
    vatFee,
    serviceFee,
    extraFee,
    discountAmount,
    total,
    totalQuantityFoodItem,
  } = data

  const { externalPartner, paymentType } = getInfoRestaurant()

  const onOpenPopupPayment = () => {
    setIsOpenPopup(true)
  }

  const onClosePopupPayment = () => {
    setIsOpenPopup(false)
  }

  const onConfirmPayment = () => {
    onClosePopupPayment()

    dispatch(requestPayment())
  }

  const goBackHandler = () => {
    navigate(-1)
  }

  const renderHeaderPayment = () => {
    return (
      <HeaderTable
        onGoBack={goBackHandler}
        name={table.name}
        colorText={currentThemeObject.colorText1}
        orderCode={table?.order_code}
      />
    )
  }

  const renderSummaryPayment = () => {
    return (
      <SummaryPayment
        total={total}
        subTotal={subTotal}
        vatMoney={vatFee}
        vatPercent={restaurant.vatRate}
        servicePercent={restaurant.serviceRate}
        serviceMoney={serviceFee}
        colorText={currentThemeObject.colorText1}
        extraFee={extraFee}
        discountAmount={discountAmount}
      />
    )
  }

  const renderListFoodOrderDetail = () => {
    if (isInValidArray(servingRequests)) return null

    return servingRequests.map((foodItem) => {
      const { id, name, quantity, foodOptionTypes, note, price } = foodItem

      const totalPriceIncludeTopping =
        externalPartner === 'loop' ? price : getTotalPriceIncludeTopping(foodItem)
      return (
        <FoodItemOrder
          key={id}
          foodOptionTypes={foodOptionTypes}
          name={name}
          note={note}
          price={totalPriceIncludeTopping}
          quantity={quantity}
          color={'baseColor.colorText1'}
          vat_amount={foodItem?.vat_amount}
        />
      )
    })
  }

  const renderOrderDetails = () => {
    return (
      <Box paddingTop="30px">
        <HeaderFoodOrder
          label={t('titles.order_details')}
          value={`${totalQuantityFoodItem} ${t('label.items')}`}
          color={'baseColor.colorText1'}
        />
        {renderListFoodOrderDetail()}
      </Box>
    )
  }

  const renderContentPayment = () => {
    return (
      <Box>
        {renderSummaryPayment()}
        {servingRequests.length > 0 && <ExcludesVAT />}
        {renderOrderDetails()}
      </Box>
    )
  }

  const renderFooterPayment = () => {
    if (paymentType === paymentTypes.pay_in_advance) return null
    return (
      <FooterSticky>
        <Button
          sx={styles.bntPay}
          variant={variantStyles.btnAddToOrder}
          onClick={onOpenPopupPayment}>
          {t('actions.pay')}
        </Button>
      </FooterSticky>
    )
  }

  useEffect(() => {
    dispatch(fetchInfoPayment())

    // if (errorData?.message === 'NEED_TO_RESCAN_QR') {
    //   localStorage.removeItem(STORAGE_KEYS.servingToken)
    //   navigate(path.rescanQR)
    // }

    return () => {
      dispatch(resetStatePayment())
    }
    // , errorData, navigate
  }, [dispatch, i18n.language])

  // Nếu request thành công => chuyển đến màn success.
  useEffect(() => {
    if (request) {
      const url = `${route.confirmedPayment}/${keywordScreen.payment}`
      navigate(url)
    }
  }, [request, navigate])

  // Xử lý trong trường hợp message lỗi trả về need to rescan qr
  useEffect(() => {
    if (error?.data?.message === errorMessage.NEED_TO_RESCAN_QR) {
      navigate(path.rescanQR)
      localStorage.clear()
    }
  }, [error?.data?.message, navigate])

  if (loading === loadingStates.pending) return <Loading />

  if (error && error?.status === STATUS_CODE.NOT_FOUND) return <OrderEmpty />

  if (error) return <ErrorServer />

  return (
    <Box bgcolor={'baseColor.color1'} flex={1} minHeight="100vh">
      <Box marginX={`${marginX}px`} paddingBottom={`${heightFooterSticky + 87}px`}>
        {renderHeaderPayment()}
        {renderContentPayment()}
        {renderFooterPayment()}
      </Box>
      <PopupPayment
        open={isOpenPopup}
        onClosePopup={onClosePopupPayment}
        onConfirm={onConfirmPayment}
      />
    </Box>
  )
}

export default React.memo(Payment)

const styles = {
  bntPay: {
    padding: '4px 8px',
    minWidth: '230px',
    fontSize: '2.2rem',
    fontWeight: '600',
  },
}
